<template>
  <div class="TabsHead">
    <Tab
      v-for="name in tabs"
      :key="name"
      :isActive="active === name"
      @click="$emit('update:active', name)">
      {{ name }}
      <slot :isActive="active === name" name="tabSuffix" />
    </Tab>
  </div>
</template>

<script>
import Tab from 'components/Tab'

export default {
  components: { Tab },
  props: {
    active: String,
    tabs: Array,
  },
}
</script>

<style lang="scss">
.TabsHead {
  border-bottom: 1px solid $border-color;
  margin-bottom: 1rem;
}
</style>
